import ProductCard from "../ProductCard/ProductCard";
import styles from "./ProductGrid.module.css";

function ProductGrid({
  products = [],
  onProductClick,
}) {
  return (
    <section className={styles.grid}>
      {products.map((product, index) => (
        <ProductCard
          key={product.id ?? index}
          {...product}
          onClick={() => onProductClick(product)}
        />
      ))}
    </section>
  );
}

export default ProductGrid;